import { API, authClient } from "../index";

export const postOfferProduct = async (offerProduct, accessToken) => {
  return authClient(accessToken).post(`${API}/offer-products`, offerProduct);
};

export const postOfferProductNewRevision = async (
  id,
  offerProduct,
  accessToken
) => {
  return authClient(accessToken).post(
    `${API}/offer-products/${id}`,
    offerProduct
  );
};

export const getOfferProducts = (accessToken) => {
  return authClient(accessToken).get(`${API}/offer-products`);
};

export const getOfferProductByIdAndRevision = (
  id,
  revisionNumber,
  accessToken
) => {
  return authClient(accessToken).get(
    `${API}/offer-products/${id}?revision=${revisionNumber}`
  );
};

export const updateOfferProduct = async (id, offerProduct, accessToken) => {
  return authClient(accessToken).put(
    `${API}/offer-products/${id}`,
    offerProduct
  );
};

export const updateProductOriginal = async (id, offerProduct, accessToken) => {
  return authClient(accessToken).put(
    `${API}/offer-products/${id}/original`,
    offerProduct
  );
};

export const reorderOfferProduct = async (id, reorderData, accessToken) => {
  return authClient(accessToken).put(
    `${API}/offer-products/${id}/position`,
    reorderData
  );
};

export const deleteOfferProduct = (productId, accessToken) => {
  return authClient(accessToken).delete(`${API}/offer-products/${productId}`);
};
